import styled from 'styled-components'

import { Box } from '../Box'
import { Button } from '../Button'
import { Space } from '../Space'
import { Title, Text } from '../Text'
import { themeSpace, themeColor, themeFontSize } from '../theme'

export interface ProductAdvertProps {
  title: string
  productCmsHtmlContent: string
  price: string
  oldPrice: string
  externalUrl?: string

  onAddToCart?(): void
  onBuyNow?(): void
}

const ProductAdvertContainer = styled(Box)`
  transition: transform 0.15s ease-in-out;
  filter: blur(0);

  &:hover {
    transform: scale(1.03);
  }
`

const Content = styled(Space)`
  flex-direction: column;
  padding: ${themeSpace(3)};
  width: 100%;
  border: 1px solid ${themeColor('borderPrimary')};
  border-bottom: none;
  border-radius: 4px 4px 0 0;
  background: ${themeColor('white')};
`

const ActionButton = styled(Button)`
  width: 50%;
  height: 60px;
  justify-content: center;
`

const Buttons = styled.div`
  display: flex;

  & > ${ActionButton}:first-child {
    border-radius: 0 0 0 4px;
  }

  & > ${ActionButton}:last-child {
    border-radius: 0 0 4px 0;
  }
`

const Price = styled.div`
  color: ${themeColor('secondary')};
  font-weight: bold;
  font-size: ${themeFontSize('large')};
`

const OldPrice = styled.div<{ strikeThrough: boolean }>`
  position: relative;

  ${({ strikeThrough }) =>
    strikeThrough &&
    `
    &::before {
      position: absolute;
      content: '';
      left: -4px;
      top: 50%;
      right: -4px;
      border-top: 1px solid;
      border-color: inherit;
      transform: rotate(-15deg);
    }
  `}
`

export const ProductAdvert = ({
  title,
  productCmsHtmlContent,
  price,
  oldPrice,
  onAddToCart,
  onBuyNow,
  externalUrl
}: ProductAdvertProps) => {
  return (
    <ProductAdvertContainer>
      <Content space={2} direction="vertical">
        {externalUrl && (
          <a href={externalUrl}>
            <Title level="large">{title}</Title>
          </a>
        )}
        {!externalUrl && <Title level="large">{title}</Title>}
        <Text dangerouslySetInnerHTML={{ __html: productCmsHtmlContent }} />
        <Space space={2} alignItems="baseline">
          <Price>{price}</Price>
          <OldPrice strikeThrough={!!oldPrice}>{oldPrice}</OldPrice>
        </Space>
      </Content>
      <Buttons>
        <ActionButton size="large" variant="primary" onClick={onAddToCart}>
          Add to cart
        </ActionButton>
        <ActionButton size="large" variant="secondary" onClick={onBuyNow}>
          Buy now
        </ActionButton>
      </Buttons>
    </ProductAdvertContainer>
  )
}
